'use client';

import { Anchor } from '@components/common';
import { cn } from '@utils/cn';

interface TagProps {
  label: string;
  href?: string;
  className?: string;
  count?: number;
}

export const Tag = (props: TagProps) => {
  // Destructure props
  const {
    label, href, className, count,
  } = props;

  const isDisabled = typeof count === 'number' ? count === 0 : false;

  return (
    <Anchor
      aria-disabled={isDisabled}
      href={href}
      styling="none"
      className={cn(
        'border flex gap-1 rounded-full border-[#F0F2F4] bg-surface text-sm px-4 py-1.5 hover:shadow-none',
        className,
        isDisabled && 'pointer-events-none opacity-50',
      )}
    >
      <span>{label}</span>
      {typeof count === 'number' ? <span>{`(${count})`}</span> : null}
    </Anchor>
  );
};
